$(document).ready(function () {
	const COOKIE_BANNER_DELAY_MS = 1500;

	function getCookie(name) {
		const match = document.cookie
			.split('; ')
			.find(row => row.startsWith(name + '='));
		return match ? match.split('=')[1] : undefined;
	}

	function setCookie(name, value, expireDays) {
		const now = new Date();
		now.setTime(now.getTime() + expireDays * 86400 * 1000);
		document.cookie = `${name}=${value}; expires=${now.toUTCString()}; path=/`;
	}

	// COOKIES
	const $cookieAlert = $("#alertCookiePolicy").hide();
	if (getCookie('acceptedCookiesPolicy') === undefined) {
		$cookieAlert.show();
	}
	$('#btnAcceptCookiePolicy').on('click', function () {
		setCookie('acceptedCookiesPolicy', 'yes', 30);
	});
	$('#btnDeclineCookiePolicy').on('click', function () {
		setCookie('acceptedCookiesPolicy', 'no', 30);
	});

	// COOKIES TEXT
	const cookiesBtn = $('.JScookiesInfo_btn');
	cookiesBtn.text(lang_id == 'en' ? 'Show details' : 'Prikaži detalje');
	cookiesBtn.on('click', function () {
		cookiesBtn.parent().next().slideToggle('fast');
		cookiesBtn.text(function (i, text) {
			return lang_id == 'en'
				? (text == 'Show details' ? 'Hide details' : 'Show details')
				: (text == 'Prikaži detalje' ? 'Sakrij detalje' : 'Prikaži detalje');
		});
	});

	// SHOW COOKIES
	setTimeout(function () {
		$('.JScookies-part').animate({ bottom: '0' }, 700);
	}, COOKIE_BANNER_DELAY_MS);
});